import React from "react";
import { Box } from "@mui/material";

export const ACCOUNT_TYPE_PERSONA = "persona";
export const ACCOUNT_TYPE_COMPANY = "company";

export const primaryButtonSx = {
  mt: 3,
  minHeight: 42,
  py: 1.1,
  borderRadius: "8px",
  bgcolor: "#4A2CF5",
  textTransform: "none",
  fontWeight: 700,
  fontSize: 14,
  color: "#FFFFFF",
  boxShadow: "none",
  "&:hover": {
    bgcolor: "#3B23C6",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    bgcolor: "rgba(74,44,245,0.35)",
    color: "rgba(255,255,255,0.85)",
  },
};

/** Outlined secondary CTA used under auth form dividers (Sign up / Log in). */
export const secondaryOutlinedButtonSx = {
  minHeight: 42,
  py: 1.1,
  borderRadius: "8px",
  borderColor: "rgba(88,89,91,0.22)",
  bgcolor: "transparent",
  textTransform: "none",
  fontWeight: 700,
  fontSize: 14,
  color: "#4A2CF5",
  boxShadow: "none",
  "&:hover": {
    bgcolor: "rgba(74,44,245,0.04)",
    borderColor: "rgba(74,44,245,0.35)",
  },
};

export const textLinkSx = {
  p: 0,
  minWidth: 0,
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13.5,
  lineHeight: 1.4,
  color: "#4A2CF5",
  verticalAlign: "baseline",
  "&:hover": {
    bgcolor: "transparent",
    textDecoration: "underline",
  },
};

const labelSx = {
  fontWeight: 600,
  fontSize: 13,
  lineHeight: 1.25,
  color: "#58595B",
};

export function FieldLabel({ children, htmlFor, required = false }) {
  return (
    <Box
      component="label"
      htmlFor={htmlFor}
      sx={{
        display: "block",
        mb: 1,
        ...labelSx,
      }}
    >
      {children}
      {required ? (
        <Box component="span" sx={{ color: "#D32F2F", ml: 0.25 }} aria-hidden="true">
          *
        </Box>
      ) : null}
    </Box>
  );
}

export function resolveAccountType({ accountType, company }) {
  if (accountType === ACCOUNT_TYPE_PERSONA || accountType === ACCOUNT_TYPE_COMPANY) {
    return accountType;
  }
  return (company || "").trim()
    ? ACCOUNT_TYPE_COMPANY
    : ACCOUNT_TYPE_PERSONA;
}
